/**
 * A reflection as the review and the PDF show it.
 *
 * A climber who presses Enter after every word or two gets a tall column of
 * fragments that pushes the panel - and a printed page - far past the text that
 * is actually there. So a reflection with more than five line breaks in all
 * is shown on one line: every break, with the blank space around it, becomes a
 * single space. Five or fewer are kept, so a few short paragraphs still read
 * as paragraphs. The stored text is not changed.
 */
const MAX_LINE_BREAKS = 5;

export const tidyReflection = (text: string): string => {
  const breaks = text.match(/\r?\n/g)?.length ?? 0;
  if (breaks <= MAX_LINE_BREAKS) return text;
  return text.replace(/\s*\r?\n\s*/g, " ").trim();
};
